/// <reference path="jquery.blockUI.js" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    function AccountViewModel() {

        // Self-Identification
        var self = this;

        this.TemplatesLoaded = ko.observable(false);
        this.TemplateName = ko.observable("NewAccountTemplate");
        this.ForgotInformationPassword = ko.observable();
        this.ForgotInformationUsername = ko.observable();
        this.AccountSectionInfoText = ko.observable('');
        this.ShouldShowAccountSectionCustom = ko.observable(false);

        sm.portal.vm.custom.setCustomLocalizeKey(self);
        sm.portal.vm.custom.callCustomization('UpdatedForgotInfoPage',self);

        // Handlers
        this.LoadModel = function (container) {
            // update application section configurations
            if (container && container.Config) {
                viewModel.SetSectionsConfigData("Account", container.Config);
            }

            // Set the main Entity
            this.PersonFirstName(container.PersonFirstName);
            this.PersonGID(container.PersonGID);
            this.PersonID(container.PersonID);
            this.UserID(container.UserID);
            this.PersonGeneratedIdentifier(container.GeneratedIdentifier);

            if (sm.portal.utility.isNullOrEmpty(this.LoginUserName())) {
                this.LoginUserName(container.AccountUsername);
            }
            this.LoginDisplayName(container.PersonDisplayName);

            if (!sm.portal.utility.isNullOrEmpty(container.AccountUsername)) {
                self.IsUserLoggedIn();
                if (!sm.portal.utility.isNullOrEmpty(self.MySection)) {
                    self.MySection.Activate();
                }
            }

            // App Fee settings
            try {
                viewModel.HasApplicationFee(container.HasFee);
                viewModel.ApplicationFeeRequired(container.FeeRequired);

                if (container.HasFee) {
                    viewModel.AdmissionsAcademicLevelFees(container.AdmissionsAcademicLevelFees);

                }
            } catch (e) {
                // Error loading fees?
                console.log("Error Loading Fee:" + e.message);
            }

            // Password Settings
            self.PasswordRequirementMessage(container.PasswordRequirementMessage);
            self.PasswordRegex(container.PasswordRegexPattern);
            self.PasswordMinLength(container.PasswordMinLength);

            self.DataLoading(false);
            self.DataLoaded(true);
            self.UnBlockContainer();

        };
        this.PageReady = function () {
            // Ready Page
            sm.portal.ui.readyPage();
        };


        this.GetDisclaimer = function () {
    
            jQuery.blockUI();
            var url = _baseApiUri + 'api/studentportal/GetDisclaimer';
          
            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
    
                    function ApplicationFeesAmount  () {
                        var msg = "";
                        var feeCount = viewModel.AdmissionsAcademicLevelFees().length;
        
                        for (i = 0; i < feeCount; i++) {
                            msg += viewModel.AdmissionsAcademicLevelFees()[i];
        
                            if (i !== feeCount - 1) {
                                msg += ", ";
                            }
                        }
                        msg =  msg.replace(/\${2,}/g, '$');
                        return msg;
                    
                    };
        
                    let myDoc = new DOMParser();

                    let myElement = myDoc.parseFromString(data.Payload.DisclaimerOnApplyNowPage.SettingValue, 'text/html');
                
                    myElement.querySelectorAll('ul li').forEach(li => li.style.listStyleType = 'disc');
                    myElement.querySelectorAll('ul').forEach(ul => ul.style.paddingLeft = '40px');

                    var p_tag1 = Array.from(myElement.querySelectorAll('body')).map((p) => {
                            
                        if(p.innerText != ""){
                            viewModel.IsDisclaimerTextEmpty(false);
                        }else{
                            viewModel.IsDisclaimerTextEmpty(true);
                        }
                       
                        const regex = /\[(.+?)\]/g;
                        p = p.innerHTML;
                       
                        const replacedString = p.replace(regex, (_, match) => {
                            return ApplicationFeesAmount();
                        });
                        
                        return replacedString;
                    });

                        viewModel.DisclaimerText(p_tag1);

                        var container = new smapi.access.ApiContainerModel(data.Status, data.Payload);
                        viewModel.LoadModel(container);
                        jQuery.unblockUI();
                        
                    },
                    error: function (jqXHR, exception) {
                        viewModel.HandleError(exception);
                        jQuery.unblockUI();
                    }
            });
        };


        this.LoadInitialData = function () {

            jQuery.blockUI();
            var url = _baseApiUri + 'api/studentportal/getapplicationsection?sectionName=account&attemptmid=';

            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    viewModel.LoadModel(container);
                    viewModel.PageReady();
                    jQuery.unblockUI();
                },
                error: function (jqXHR, exception) {
                    viewModel.HandleError(exception);
                    sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                    jQuery.unblockUI();
                }
            });
        };

        this.InitializeAndLoginUser = function (container, successCallback, firstName, doLogin, isInitialLogin) {
            var self = this;

            // Set the appropriate variables
            this.PersonID(container.PersonID);
            this.PersonGID(container.PersonGID);
            this.UserID(container.UserID);
            this.LoginUserName(container.PortalUserName);
            this.PersonGeneratedIdentifier(container.GeneratedIdentifier);

            if (!sm.portal.utility.isNullOrEmpty(firstName)) {
                this.PersonFirstName(firstName);
            }

            if (!sm.portal.utility.isNullOrEmpty(this.NewAccountPassword)) {
                this.LoginPassword(this.NewAccountPassword());
                    var customData = {
                        self: self,
                        doLogin: doLogin,
                        isInitialLogin: isInitialLogin,
                        successCallback: successCallback
                    }
                    sm.portal.vm.custom.callCustomization('InitializeAndLoginUser', customData,function(){
                        self.JustLogin(successCallback);
                    });

            }
        };

        this.HandleError = function (title, messages) {
            this.IsError(true);
            this.ErrorMessages(messages);
            if (sm.portal.utility.isNullOrEmpty(title)) {
                viewModel.ErrorHeader(sm.portal.utility.getResourceValue('ThereWasAnError'));
            } else {
                viewModel.ErrorHeader(title);
            }
        };

        // Requirement Options
        this.IsRequired = ko.observable(true);

        // Account Values
        this.ShowNewAccount = ko.observable(true);
        this.ShowLogin = ko.observable(false);
        this.IsLoggedIn = ko.observable(false);

        // Existing Account    
        this.PersonGID = ko.observable();
        this.PersonID = ko.observable();
        this.PersonGeneratedIdentifier = ko.observable();
        this.PersonMID = ko.computed(function () {
            if (!sm.portal.utility.isNullOrEmpty(this.PersonGID())) {
                return this.PersonGID();
            } else if (!sm.portal.utility.isNullOrEmpty(this.PersonID())) {
                return this.PersonID();
            }
            return "";
        }, this);
        this.LoginAnchor = ko.computed(function () {
            return '<a href="/?u4sm_page=applicant-login" class="linkButton">Login Here</a>';
            /* '<button class="linkButton" type="button" id="NewAccountToggleButton" data-bind="click: ToggleLogin">' + sm.portal.utility.getResourceValue('LoginHere') + '</button>'; */
        });

        this.UserID = ko.observable();
        this.PersonFirstName = ko.observable();
        this.LoginUserName = ko.observable();
        this.LoginDisplayName = ko.observable();
        this.LoginPassword = ko.observable();

        // Password Requirements
        this.PasswordRequirementMessage = ko.observable();
        this.PasswordRegex = ko.observable();
        this.PasswordMinLength = ko.observable();

        this.NewAccountPassword = ko.validatedObservable();
        this.NewAccountConfirmPassword = ko.validatedObservable();

        /*** SUBSCRIPTIONS ***/
        this.NewAccountPassword.subscribe(function (newValue) {
            self.NewAccountConfirmPassword.isValid();
        }, this);
        this.NewAccountConfirmPassword.subscribe(function (newValue) {
            self.NewAccountPassword.isValid();
        }, this);
        /*** SUBSCRIPTIONS ***/

        // Already Logged In
        this.LoggedInDisplay = ko.computed(function () {
            if (!sm.portal.utility.isNullOrEmpty(this.PersonFirstName())) {
                return this.PersonFirstName();
            } else {
                return this.LoginUserName();
            }
        }, this);

        // Handlers 
        this.ToggleLogin = function () {

            if (this.ShowNewAccount()) {
                this.ShowNewAccount(false);
                this.ShowLogin(true);
                // manual focus on input field
                jQuery("#username").focus();
            } else {
                this.ShowNewAccount(true);
                this.ShowLogin(false);
            }
            if (this.MySection != null) {
                this.MySection.Activate();
            }

            viewModel.IsError(false);
        };
        this.IsUserLoggedIn = function (callback) {

            if (!sm.portal.utility.isNullOrEmpty(_currentPersonId) && _currentPersonId > 0) {

                // User is logged into the Portal - show the Logged In View
                this.IsLoggedIn(true);
                this.ShowNewAccount(false);
                this.ShowLogin(false);
                this.PersonID(_currentPersonId);

            } else if (!sm.portal.utility.isNullOrEmpty(this.LoginUserName()) && sm.portal.utility.isNullOrEmpty(this.NewAccountConfirmPassword())) {

                // We have a user ID, but they're not logged in - show the Login Form View
                this.IsLoggedIn(false);
                this.ShowNewAccount(false);
                this.ShowLogin(true);

            } else {

                // No one is logged in, no user name set - show the New Account View
                this.IsLoggedIn(false);
                this.ShowNewAccount(true);
                this.ShowLogin(false);
            }

            if (callback != undefined && callback != null) {
                callback();
            }
        };

        this.PreviousUserLogin = function () {
            var theForm = jQuery('#AccountForm');
            var data = theForm.serialize();

            if (sm.portal.utility.isNullOrEmpty(data)) {
                data = 'username=' + encodeURIComponent(this.LoginUserName()) + '&password=' + encodeURIComponent(this.LoginPassword()) + '&defaultDomain=U4SM&action=remote_login';
            }

            jQuery.blockUI();
            jQuery.ajax({
                url: _ajaxUri,
                type: 'POST',
                data: data,
                success: function (data, textStatus, jqXHR) {

                    var results = jQuery.parseJSON(data);
                    if (results.msg == 'success') {
                        // Do Refresh
                        location.reload();
                    } else if (results.msg  ===  "<strong>ERROR</strong>: Invalid username or incorrect password." ) {
                        viewModel.HandleError(results.msg);
                        jQuery.unblockUI();
                    } 
                    else {
                        viewModel.HandleError(results.msg);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'save');
                        jQuery.unblockUI();
                    }

                },
                error: function (jqXHR, exception) {
                    viewModel.HandleError(exception);
                    sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'save');
                    jQuery.unblockUI();
                }
            });

        };

        this.JustLogin = function (successCallback) {
            var theForm = jQuery("#AccountForm");
            var data = theForm.serialize();
            if (sm.portal.utility.isNullOrEmpty(data)) {
                data = "username=" + encodeURIComponent(this.LoginUserName()) + "&password=" + encodeURIComponent(this.LoginPassword()) + "&defaultDomain=U4SM&action=remote_login";
            }

            jQuery("#NewAccountPassword").attr("disabled", "disabled");
            jQuery("#NewAccountConfirmPassword").attr("disabled", "disabled");

            jQuery.ajax({
                url: _ajaxUri,
                type: 'POST',
                data: data,
                success: function (data, textStatus, jqXHR) {
                    var loginResult = JSON.parse(data);
                    if (loginResult.msg === 'success') {
                        self.GetRequestValidationTokenAndRefreshValue(function () {
                            self.SetAuthorizationContext(successCallback);
                        });

                    } else {
                        viewModel.HandleError(loginResult.msg);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'save');
                    }
                },
                error: function (jqXHR, exception) {
                    viewModel.HandleError(exception);
                    sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'save');
                    jQuery.unblockUI();
                }
            });
        };

        this.GetRequestValidationTokenAndRefreshValue = function (callback) {

            jQuery.blockUI();

            jQuery.ajax({
                type: 'GET',
                url: _baseApiUri + 'api/CSRFProtection/GetToken',
                contentType: false,
                global: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    jQuery.unblockUI();

                    if (data) {
                        jQuery('input[name=__RequestVerificationToken]').val(data);
                        callback();
                    }
                },
                error: function (jqXHR, exception) {
                    jQuery.unblockUI();
                    viewModel.HandleError(exception);
                }
            });
        }

        this.SetAuthorizationContext = function (successCallback) {
            var formData = new FormData();
            formData.append('action', 'get_authorization_info');

            jQuery.ajax({
                url: _ajaxUri,
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function (data, textStatus, jqXHR) {
                    var authorizationInfo = jQuery.parseJSON(data);

                    if (authorizationInfo.msg == 'success') {
                        _currentPersonId = authorizationInfo.CurrentPersonId;
                        _currentStudentId = authorizationInfo.CurrentStudentId;
                        _currentAdvisorId = authorizationInfo.CurrentAdvisorId;

                        self.IsUserLoggedIn();
                        self.ReplaceLoggedInHeader(authorizationInfo.LogoutUrl);
                        scriptParams.LogoutURL = authorizationInfo.LogoutUrl;

                        sm.portal.vm.custom.callCustomization('IdleLogoutUser');

                        if (successCallback && typeof successCallback === "function") {
                            successCallback();
                        }
                    } else {
                        viewModel.HandleError(authorizationInfo.msg);
                    }
                },
                error: function (jqXHR, exception) {
                    viewModel.HandleError(exception);
                    jQuery.unblockUI();
                }
            });
        }

        this.ReplaceLoggedInHeader = function (logoutUrl) {
            var _logoutUrl = logoutUrl;

            var viewModel = {
                LoginUserName: self.LoginUserName(),
                Logout: function () {
                    window.location.href = _logoutUrl;
                }
            };

            var template = jQuery('#loggedInPageHeaderTemplate').text();
            var smQuickLinks = jQuery('nav div.smQuickLinks');
            var customData = {
                smQuickLinks: smQuickLinks,
                _logoutUrl: _logoutUrl
            }
            smQuickLinks.html(template);
 
            sm.portal.vm.custom.callCustomization('UpdatedsmQuickLinks', customData, function(){
                ko.cleanNode(smQuickLinks[0]);
                ko.applyBindings(viewModel, smQuickLinks[0])});

        };

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("AccountContainer");
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);

        this.MySection = null;
        /*** SECTION PROPERTIES ***/

        /*** SECTION METHODS ***/
        this.Initialize = function (section) {
            this.MySection = section;
            // Change the Section Template accordingly...this should only get called on the Application...
            if (self.ShowNewAccount()) {
            var loadTemplate = sm.portal.vm.custom.callCustomization('TemplateToLoad',section);
                if(sm.portal.utility.isNullOrEmpty(loadTemplate)){
                    section.SectionTemplate("NewAccountTemplate");
                }
            } else if (self.IsLoggedIn()) {
                section.SectionTemplate("LoggedInTemplate");
            } else {
                section.SectionTemplate("AccountTemplate");
            }
        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            
            if (!self.DataLoaded() && !self.DataLoading()) {

                self.DataLoading(true);
                if(!sm.portal.utility.isNullOrEmpty(viewModel.allCustomData())) {
                    self.LoadModel(viewModel.allCustomData().Account.Payload);
                    self.GetDisclaimer();
                    callback && callback(viewModel.allCustomData().Account.Payload);
                    return;
                }
                if (blockui) { self.BlockContainer() }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=account&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                        if (data.Status == 'success') {
                            self.LoadModel(container.Payload);
                            self.GetDisclaimer();
                        }
                        else if (data.Status == 'validationerror') {
                            viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                            sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        } else if (data.Status == 'error') {
                            var cnt = self.DataLoadErrorCount() + 1;
                            self.DataLoadErrorCount(cnt);

                            if (cnt <= 1) {      // 1 extra try
                                self.DataLoaded(false);
                                self.DataLoading(false);
                                self.GetModelData(false, applicationMID, personMID);
                            } else {
                                viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                                sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                            }
                        }
                        self.UnBlockContainer();
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        var statusText = jqXHR.statusText;
                        var responseMsg = sm.portal.utility.getResourceValue('UnknownError');

                        try {
                            if (jqXHR != null && jqXHR.responseText != null) {
                                responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                            }
                        } catch (e) {
                            responseMsg = sm.portal.utility.getResourceValue('CouldNotRetrieveErrorMessage');
                        }

                        var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
                        viewModel.HandleError(sm.portal.utility.getResourceValue('ErrorRetrievingSectionData'), [messageToUser]);
                        self.UnBlockContainer();
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };
        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            try { viewModel.SetFocus(); } catch (e) { }
        };
        this.ProcessOnServer = function () {
            return true;
        };
        /*** SECTION METHODS ***/

        // Error Handling
        this.ErrorHeader = ko.observable();
        this.ErrorMessages = ko.observableArray();
        this.IsError = ko.observable();

        // Extraction Method
        this.ExtractATO = function () {
            var submitObject = ko.mapping.toJS(this);
            var data = {
                AccountPassword: submitObject.NewAccountPassword,
                PersonID: submitObject.PersonID,
                PersonGID: submitObject.PersonGID
            };

            return data;
        };

        /*** VALIDATION METHODS ***/
        // NOTE: ALL Custom Rules for these fields
        this.NewAccountPassword.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
                onlyIf: function () {
                    return self.IsRequired() === true && self.ShowNewAccount() === true;
                }
            },
            smPasswordLength: {
                params: [self.PasswordMinLength, self.PasswordRequirementMessage, self.IsRequired],
                onlyIf: function () {
                    return self.ShowNewAccount() === true;
                }
            },
            smPasswordPattern: {
                params: [self.PasswordRegex, self.PasswordRequirementMessage, self.IsRequired],
                onlyIf: function () {
                    return self.ShowNewAccount() === true;
                }
            }
        });
        this.NewAccountConfirmPassword.extend({
            smMatchingValue: {
                params: self.NewAccountPassword,
                message: sm.portal.utility.getResourceValue('PasswordsDoNoMatch'),
                onlyIf: function () {
                    return self.ShowNewAccount() === true;
                }
            },
            validation: {
                validator: function (val, valueToCompare) {
                    return valueToCompare == val;
                },
                message: sm.portal.utility.getResourceValue('PasswordsDoNoMatch'),
                params: self.NewAccountPassword
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = true;

            if (this.ShowLogin()) {
                isCompleted = false;
            } else if (this.ShowNewAccount()) {
                isCompleted = this.IsVMValid();
            } else if (!this.IsLoggedIn()) {
                isCompleted = false;
            }

            return isCompleted;

        }, this);
        this.AllowNext = ko.computed(function () {
            if (sm.portal.utility.isNullOrEmpty(this.NewAccountPassword()) || sm.portal.utility.isNullOrEmpty(this.NewAccountConfirmPassword())) {
                return false;
            }
            return this.NewAccountPassword() === this.NewAccountConfirmPassword();
        }, this);
        this.LostUsernameUrl = ko.computed(function () {
           var defaultUserLink = window.location.origin + '/u4sm_page/forgot-information/?option=ma_show_email_user'; 
           var wp_user_link = jQuery('#lost_User_link').attr('href');
            // check for link is available or not in wordpress
            if (wp_user_link) {
                return wp_user_link;
            }
            
            return defaultUserLink;      
        });
        this.LostPasswordUrl = ko.computed(function () {
            var defaultPassLink = window.location.origin + '/u4sm_page/forgot-information/?option=ma_show_email_password';
            var wp_pass_link = jQuery('#lost_Pass_link').attr('href');
          // check for link is available or not in wordpress
            if (wp_pass_link) {
                return wp_pass_link;
            }
         
            return defaultPassLink;
        });
        /*** VALIDATION METHODS ***/

        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        AccountViewModel: AccountViewModel
    });

})(jQuery);